import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Login from './Login';
import CustomerList from './CustomerList';
import logo from "./logo.svg";

function App() {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const handleLogin = async (username, password) => {
    try {
      const sendData = new FormData();
      sendData.append('username', username);
      sendData.append('password', password);
      const response = await fetch('/api/token/', {
        method: 'POST',
        body: sendData
      });
      const data = await response.json();
      const token = data.access_token; // Assuming the response is { "access_token": "Bearer ..." }
      setToken(token);
      localStorage.setItem('token', token);
    } catch (error) {
      console.error('Error fetching token:', error);
    }
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token');
  };

  return (
      <Router>
        <div className="App">
          {token!==null ? <button className="LogoutButton" onClick={() => handleLogout()}>Logout</button> : ""}
          <div className={'mainTitleContainer'}>
            <div>Updater backend</div>
          </div>
          <img src={logo} alt="SniperCam" width="200"/>
          <Routes>
            <Route path="/login" element={token ? <Navigate to="/"/> : <Login onLogin={handleLogin}/>}/>
            <Route index path="/" element={token ? <Navigate to="/customers"/> : <Navigate to="/login"/>}/>
            <Route index path="/customers"
                   element={token ? <CustomerList token={token} onLogout={handleLogout}/> : <Navigate to="/login"/>}/>
          </Routes>
        </div>
      </Router>
  );
}

export default App;